import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import ActionOptions from "./ActionOptions";
import ActionIcon from "./ActionIcon";
import { getInterlocutorFullname } from "../../../../Utils/prospect";

const Action = ({ data, isOpen, setIsOpen }) => {
  const { t } = useTranslation("common");
  const { status, date, comment, description, type, isReminder, interlocutor } =
    data;

  const fullName = getInterlocutorFullname(interlocutor?.data);
  const occupation = interlocutor?.data?.attributes?.occupation;

  return (
    <div
      className="cursor-pointer position-relative py-4 ps-4 pe-5"
      onClick={() => setIsOpen(isOpen === data?.id ? null : data?.id)}
    >
      <div className="d-flex align-items-center gap-4">
        <div
          className={`position-absolute br5 z-n1 top-0 start-0 w-100 h-100 ${
            isOpen === data?.id
              ? isReminder
                ? "bg-bronze-400"
                : "bg-blue-300"
              : ""
          }`}
        ></div>
        <ActionIcon isReminder={isReminder} type={type} />
        <div className="d-flex flex-column">
          <p className="f13 text-ultraBlack mb-0 medium">
            {t(`${status ?? ""}`)}
          </p>
          <p className="f13 text-ultraBlack mb-0 medium">
            {isReminder ? (
              <span className="text-uppercase">
                {date ? (
                  <span className="bold">{`${moment(date).format(
                    "DD/MM/YYYY"
                  )} -`}</span>
                ) : (
                  ""
                )}{" "}
                {`${t("Reminder")} -`} {t(`${type ?? ""}`)}{" "}
              </span>
            ) : (
              <span className="text-uppercase">
                {date ? (
                  <span className="bold">{`${moment(date).format(
                    "DD/MM/YYYY"
                  )} -`}</span>
                ) : (
                  ""
                )}{" "}
                {t(`${type ?? ""}`)}{" "}
                {description?.length > 0 ? `- ${description}` : ""}
              </span>
            )}
          </p>
          <p className="f13 text-ultraBlack mb-0 medium">
            {fullName?.length > 0 ? `${t("Interlocutor")} -` : ""}{" "}
            {fullName ?? ""} {occupation ? `- ${occupation}` : ""}
          </p>
        </div>
      </div>
      {isOpen === data?.id && (
        <>
          {comment?.length > 0 && (
            <div className="d-flex flex-column f14 ps-5 ms-4 text-ultraBlack mt-2">
              <span>{t("Comment Action")} :</span>
              <p className="mb-0">{comment}</p>
            </div>
          )}
          <ActionOptions isReminder={isReminder} actionData={data} />
        </>
      )}
    </div>
  );
};

export default Action;
